import React from 'react';

import MatchScoresStatsLoader from './MatchScoresStatsLoader';
import { useJobProspectsStatsState, useJobProspectsStatsActions } from './JobProspectsStatsContext';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import { scheduleMatchScoreCalculation } from './restApi';
import styles from './MatchScoresStats.module.scss';

const MatchScoresStats = () => {
  const state = useJobProspectsStatsState();
  const { onResponse, onError } = useJobProspectsStatsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleScheduleMatchScores = () => {
    scheduleMatchScoreCalculation({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <>
      <MatchScoresStatsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Match Scores Statistics" />
          <div style={{ marginBottom: '1rem' }}>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats'}
            >
              ← Back to Stats Overview
            </Button>
          </div>
          
          {state?.loading && <p>Loading...</p>}
          
          {state?.feedbackVariant === 'error' && (
            <p style={{ color: 'red' }}>Error: {state?.feedbackMessage}</p>
          )}
          
          {!state?.loading && state?.feedbackVariant !== 'error' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <p><strong>Total Match Scores:</strong> {state?.total}</p>
              <p><strong>Match Scores for Job Descriptions from External Websites:</strong> {state?.with_job_descriptions_from_external_websites}</p>
              <hr />
              <p><strong>Average Match Score:</strong> {state?.average_match_score || 'N/A'}</p>
              <p><strong>Standard Deviation:</strong> {state?.standard_deviation || 'N/A'}</p>
              <p><strong>Maximum Match Score:</strong> {state?.max_match_score || 'N/A'}</p>
              <p><strong>Minimum Match Score:</strong> {state?.min_match_score || 'N/A'}</p>
              <hr />
              <p><strong>High Match Scores ({'>'}= 0.7):</strong> {state?.high_match_scores}</p>
              <p><strong>Medium Match Scores (0.4 - 0.7):</strong> {state?.medium_match_scores}</p>
              <p><strong>Low Match Scores ({'<'} 0.4):</strong> {state?.low_match_scores}</p>
              
              {state?.distribution && (
                <>
                  <hr />
                  <p><strong>Distribution by Standard Deviations from Mean:</strong></p>
                  <div style={{ marginLeft: '1rem' }}>
                    <p><em>Below Mean:</em></p>
                    <div style={{ marginLeft: '1rem' }}>
                      <p>Less than 1 std dev below: {state?.distribution.below_mean.less_than_1_std_dev}</p>
                      <p>1 to 1.5 std dev below: {state?.distribution.below_mean.one_to_1_5_std_dev}</p>
                      <p>1.5 to 2 std dev below: {state?.distribution.below_mean.one_5_to_2_std_dev}</p>
                      <p>Greater than 2 std dev below: {state?.distribution.below_mean.greater_than_2_std_dev}</p>
                    </div>
                    <p><em>Above Mean:</em></p>
                    <div style={{ marginLeft: '1rem' }}>
                      <p>Less than 1 std dev above: {state?.distribution.above_mean.less_than_1_std_dev}</p>
                      <p>1 to 1.5 std dev above: {state?.distribution.above_mean.one_to_1_5_std_dev}</p>
                      <p>1.5 to 2 std dev above: {state?.distribution.above_mean.one_5_to_2_std_dev}</p>
                      <p>Greater than 2 std dev above: {state?.distribution.above_mean.greater_than_2_std_dev}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          
          <ActionRow>
            <Button onClick={handleScheduleMatchScores}>
              Schedule Match Score Calculation
            </Button>
          </ActionRow>
        </Stack>
      </div>
    </>
  );
};

export default MatchScoresStats;
